import { render, staticRenderFns } from "./CentralCounterParty.vue?vue&type=template&id=b4077e36&"
import script from "./CentralCounterParty.vue?vue&type=script&lang=js&"
export * from "./CentralCounterParty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports